<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p561js/tc-custom/9780062105745.jpg?1718282660176" alt="This image is the cover for the book Girls Like Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girls Like Us
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Powerfully raw, deeply moving, and utterly authentic. Rachel Lloyd has turned a personal atrocity into triumph and is nothing less than a true hero.... Never again will you look at young girls on the street as one of 'those' women—you will only see little girls that are girls just like us." —Demi Moore, actress and activist </b></p><p>With the power and verity of <i>First They Killed My Father </i>and <i>A Long Way Gone</i>, Rachel Lloyd’s riveting survivor story is the true tale of her hard-won escape from the commercial sex industry and her bold founding of GEMS, New York City’s Girls Education and Mentoring Service, to help countless other young girls escape "the life." Lloyd’s unflinchingly honest memoir is a powerful and unforgettable story of inhuman abuse, enduring hope, and the promise of redemption. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Lloyd
      </h2>
      
      <p class="authorDescription body article"><P>Rachel Lloyd is the founder and executive director of GEMS, Girls Educational and Mentoring Services. The recipient of numerous fellowships and honors, including the prestigious Reebok Human Rights Award, Lloyd was a leading advocate for the Safe Harbor for Exploited Youth Act, which made New York the first state to protect, not prosecute, sexually exploited children. She lives in New York City.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32e5bec8